import {
  ADD_NEW_COMMENT_FULFILLED,
  ADD_NEW_COMMENT_PENDING,
  ADD_NEW_COMMENT_REJECTED,
  LOAD_ALL_COMMENTS_FULFILLED,
  LOAD_ALL_COMMENTS_PENDING,
  LOAD_ALL_COMMENTS_REJECTED,
  SET_COMMENT_FORM,
} from '../../actions';

import {fromJS, List, Map} from 'immutable';

const initialState = new Map({
  comments: new List(),
  loading: false,
  model: new Map({
    lessonPlanId: 0,
    text: '',
    userId: 0,
  }),
  submitting: false,
});

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_NEW_COMMENT_PENDING:
      return state.set('submitting', true);

    case ADD_NEW_COMMENT_REJECTED:
      return state.set('submitting', false);

    case ADD_NEW_COMMENT_FULFILLED:
      return state.withMutations(map => map.set('submitting', false)
          .set('loading', false)
          .set('comments', map.get('comments').unshift(fromJS(action.payload.data)))
          .setIn(['model', 'text'], ''));

    case SET_COMMENT_FORM:
      return state.setIn(['model', action.payload.name], action.payload.value);

    case LOAD_ALL_COMMENTS_PENDING:
      return state.set('loading', true);

    case LOAD_ALL_COMMENTS_REJECTED:
      return state.set('loading', false);

    case LOAD_ALL_COMMENTS_FULFILLED:
      return state.withMutations(map => map.set('loading', false)
          .set('comments', fromJS(action.payload.data)));

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./app/features/comments/reducers/pages/commentsSection.js